import { get } from 'lodash';

export class BasicDetailsForm {
  public dob: { day?: number, month?: number, year?: number };
  public gender: string | undefined;
  public smoker: string | undefined;
  public occupationName: string | undefined;
  public nationalityCode: string | undefined;
  public required1: boolean;
  public required2: boolean;
  public required3: boolean;
  public required4: boolean;
  constructor(initial: any) {
    this.dob = get(initial, 'dob', { day: undefined, month: undefined, year: undefined });
    this.gender = get(initial, 'gender', undefined);
    this.smoker = get(initial, 'smoker', undefined);
    this.occupationName = get(initial, 'occupationName', undefined);
    this.nationalityCode = get(initial, 'nationalityCode', undefined);
    this.required1 = get(initial, 'required1', false);
    this.required2 = get(initial, 'required2', false);
    this.required3 = get(initial, 'required3', false);
    this.required4 = get(initial, 'required4', false);
  }
}